<template>
  <div class="main">
    <div class="box1">
      <div class="box">
        <img src="@/assets/tabs/chart.png" alt="">
        <div class="rightBox">
          <div class="title">TCO采购总成本中包装品类占比低但和其他品类有着相同管理成本</div>
          <p class="text">包装在总体物料采购成本中占比低，而在管理成本和库存成本上成本高，所以传统以“物料价格”为导向的采购成本管理观念亟需转型为TCO战略成本管理意识</p>
          <div class="title2">如何解决企业供应链管理成本过高的问题？</div>
          <p class="text2">建立线上线下协同服务体系 ， 构建多元化的产业网络和供应网络，以数据为驱动的包装研发设计与制造活动的多部门在线协同作用 </p>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="box">
        <div class="title">
          场景应用，助力不同部门协同办公，降低TCO包装总成本
        </div>
        <div class="contentBox">
          <div>
            <div class="tab" @mouseenter="active=1">
              <img :src="active == 1 ? require('@/assets/tabs/icon1_active.png') : require('@/assets/tabs/icon1.png')">
              <div>
                <div class="name" :style="{'color':active == 1 ? '#3359CC':'#333333'}">采购部</div>
                <div class="text" :style="{'color':active == 1 ? '#3359CC':'#333333'}">数据管理员</div>
              </div>
            </div>
            <div class="tab" @mouseenter="active=2">
              <img :src="active == 2 ? require('@/assets/tabs/icon2_active.png') : require('@/assets/tabs/icon2.png')">
              <div>
                <div class="name" :style="{'color':active == 2 ? '#3359CC':'#333333'}">财务部</div>
                <div class="text" :style="{'color':active == 2 ? '#3359CC':'#333333'}">对账开票</div>
              </div>
            </div>
            <div class="tab" @mouseenter="active=3">
              <img :src="active == 3 ? require('@/assets/tabs/icon3_active.png') : require('@/assets/tabs/icon3.png')">
              <div>
                <div class="name" :style="{'color':active == 3 ? '#3359CC':'#333333'}">质量部</div>
                <div class="text" :style="{'color':active == 3 ? '#3359CC':'#333333'}">质量管理</div>
              </div>
            </div>
          </div>
          <div class="showImg">
            <img v-if="active == 1" src="@/assets/tabs/showImg1.png">
            <img v-if="active == 2" src="@/assets/tabs/showImg2.png">
            <img v-if="active == 3" src="@/assets/tabs/showImg3.png">
            <img v-if="active == 4" src="@/assets/tabs/showImg4.png">
            <img v-if="active == 5" src="@/assets/tabs/showImg5.png">
            <img v-if="active == 6" src="@/assets/tabs/showImg6.png">
          </div>
          <div>
            <div class="tab" @mouseenter="active=4">
              <img :src="active == 4 ? require('@/assets/tabs/icon4_active.png') : require('@/assets/tabs/icon4.png')">
              <div>
                <div class="name" :style="{'color':active == 4 ? '#3359CC':'#333333'}">工程部</div>
                <div class="text" :style="{'color':active == 4 ? '#3359CC':'#333333'}">包装图纸库</div>
              </div>
            </div>
            <div class="tab" @mouseenter="active=5">
              <img :src="active == 5 ? require('@/assets/tabs/icon5_active.png') : require('@/assets/tabs/icon5.png')">
              <div>
                <div class="name" :style="{'color':active == 5 ? '#3359CC':'#333333'}">生产部</div>
                <div class="text" :style="{'color':active == 5 ? '#3359CC':'#333333'}">预约送货,到货提醒</div>
              </div>
            </div>
            <div class="tab" @mouseenter="active=6">
              <img :src="active == 6 ? require('@/assets/tabs/icon6_active.png') : require('@/assets/tabs/icon6.png')">
              <div>
                <div class="name" :style="{'color':active == 6 ? '#3359CC':'#333333'}">仓储部</div>
                <div class="text" :style="{'color':active == 6 ? '#3359CC':'#333333'}">送货进度,在线签收</div>
              </div>
            </div>
          </div>
        </div>
        <div class="tip">
          <span v-if="active == 1">在线统一数据管理，各部门角色分配</span>
          <span v-if="active == 2">在线对账开票</span>
          <span v-if="active == 3">在线查看实时检验报告，在线质量投诉和8D报告</span>
          <span v-if="active == 4">在线查询最新图纸</span>
          <span v-if="active == 5">柔性排产准时生产</span>
          <span v-if="active == 6">提前收货准备，在线查询送货单</span>
        </div>
      </div>
    </div>
    <div class="box3">
      <div class="box">
        <div class="title">
          数字化JIT系统级API数据对接 逐步实现真正零库存
        </div>
        <div class="contentBox">
          <div class="carousel">
            <!-- <el-carousel :interval="4000" type="card" height="200px">
              <el-carousel-item v-for="item in carouselList" :key="item">
                <img class="carouselImg" :src="item">
              </el-carousel-item>
            </el-carousel> -->
            <el-carousel :interval="3500" height="322px" style="width:543px;" @change="change">
              <el-carousel-item v-for="item in carouselList" :key="item">
                <!-- <h3 class="small">{{ item }}</h3> -->
                <img class="carouselImg" :src="item">

              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="rightBox" v-if="active2==0">
            <div class="title">数字化准时制 Digital JIT</div>
            <div class="text">物流车辆实时追踪，提升物流效率仓库人员在线签收入库系统自动通知相关部门贯穿至生产工厂的库存数据,实时掌握库存动态</div>
            <div class="text">根据美国供应链管理协会分析供应链信息化平均可以帮助企业降低 <span>20%</span> 到 <span>40%</span> 的库存</div>
          </div>
          <div class="rightBox" v-if="active2==1">
            <div class="title">系统级API数据对接</div>
            <div class="text">API数据对接，实现企业间的信息交互，运用IOT、RFID等技术，建立包装无人仓库，进一步的Consignment，实现包装物料出库暨入库</div>
            <div class="text">系统级API数据对接，提高供应链的可视性和可预测性，可以帮助企业实现真正 <span>零库存</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="box4">
      <div class="box">
        <div class="leftBox">
          <div class="title">多维度多层次的能力协助包装物料成本的降低</div>
          <div class="subtitle">基于包装性能的模块化设计</div>
          <div class="text">通过拥有17000款SKU以上的包装数据库、模块化设计，实现生产规模化带来的成本节约</div>
          <div class="subtitle">多品种小批量的敏捷供应链</div>
          <div class="text">通过使用年2000万以下的包装工厂，不仅实现灵活生产，更能实现成本最优</div>
        </div>
        <div>
          <img class="chart" src="@/assets/tabs/chart2.png">
        </div>
      </div>
    </div>
    <div class="box5">
      <div class="box">
        <div class="leftBox">
          <div class="title">如何实现采购整体供应链路保证？</div>
          <div class="subtitle">供应保证</div>
          <div class="text">800+各类包装工厂汇聚平台，共同协同为企业服务 </div>
          <div class="text">MES（生产管理系统）链接企业和工厂，生产过程实时化</div>
          <div class="text">TMS（物流管理系统）实时在途追踪物流运输</div>
          <div class="text">QMS（质量管理系统）确保不同供应商达到相同质量要求</div>
        </div>
        <div>
          <router-link class="btn" :to="{path: '/services', query: {anchorPoint: 'promise' }}">查看更多</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 1,
      active2: 0,
      carouselList: [
        'https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/carouse1.png',
        'https://manybox.oss-cn-shanghai.aliyuncs.com/officialWebsite/carouse2.png'
      ]
    }
  },
  mounted() {
    this.timeChange()
  },
  computed: {},
  created() {
  },
  methods: {
    timeChange() {
      setTimeout(() => {
        this.active++
        if (this.active == 7) {
          this.active = 1
        }
        this.timeChange()
      }, 3500)
    },
    change(index) {
      this.active2 = index
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.box1 {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 150px;
  background: linear-gradient(180deg, #f7f8fb 0%, rgba(247, 248, 251, 0) 100%);
  .box {
    width: 1200px;
    display: flex;
    align-items: center;
    img {
      width: 734px;
      height: 559px;
      margin-left: -30px;
    }
    .rightBox {
      width: 580px;
      margin-left: -60px;
      .title {
        font-size: 36px;
        line-height: 42px;
      }
      .text {
        font-size: 14px;
        margin-top: 20px;
        color: #666666;
        line-height: 42px;
      }
      .title2 {
        font-size: 26px;
        color: #3359cc;
        font-weight: 500;
        line-height: 30px;
        margin: 66px 0 28px 0;
      }
      .text2 {
        font-size: 18px;
        font-weight: 500;
        color: #666666;
      }
    }
  }
}
.box2 {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 162px;
  .box {
    // display: flex;
    // justify-content: center;
    // flex-direction: column;
    width: 1200px;
    .title {
      width: 652px;
      font-size: 36px;
      text-align: center;
      margin: 0 auto;
    }
    .contentBox {
      margin-top: 74px;
      display: flex;
      justify-content: space-between;
      .tab {
        display: flex;
        align-items: center;
        text-align: left;
        // width: 189px;
        margin-bottom: 45px;
        cursor: pointer;
        img {
          width: 54px;
          height: 54px;
          margin-right: 21px;
        }
        .name {
          font-size: 24px;
          line-height: 40px;
        }
        .text {
          color: #333333;
          font-size: 16px;
        }
      }
      .showImg {
        width: 744px;
        height: 250px;
        margin-top: 15px;
        background-image: url("../../../assets/tabs/tab2Bg.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img {
          width: 424px;
          height: 389px;
        }
      }
    }
    .tip {
      margin-top: 40px;
      font-size: 16px;
      color: #333333;
      text-align: center;
    }
  }
}
.box3 {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 162px;
  .box {
    display: flex;
    width: 1200px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .title {
      width: 505px;
      text-align: center;
      font-size: 36px;
      font-weight: 500;
    }
    .contentBox {
      display: flex;
      flex-direction: initial;
      justify-content: space-between;
      width: 100%;
      margin: 132px 0 198px 0;
      align-items: center;
      .carousel {
        // width: 50%;
        // flex: 1;
        // height: 130px;
        .carouselImg {
          width: 543px;
          height: 322px;
        }
      }
      .rightBox {
        // text-align: left;
        margin-left: 76px;
        .title {
          text-align: left;
          font-size: 24px;
          margin-bottom: 48px;
        }
        .text {
          width: 392px;
          font-size: 14px;
          color: #666666;
          margin-bottom: 30px;
          span {
            color: #789aff;
            font-size: 20px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
.box4 {
  width: 100%;
  display: flex;
  justify-content: center;
  // padding-top: 162px;
  .box {
    display: flex;
    width: 1200px;
    justify-content: center;
    // flex-direction: column;
    align-items: center;
    .leftBox {
      .title {
        width: 405px;
        height: 106px;
        font-size: 36px;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
        margin-bottom: 64px;
      }
      .subtitle {
        font-size: 24px;
      }
      .text {
        font-size: 14px;
        margin-bottom: 41px;
        color: #666666;
        line-height: 32px;
      }
    }

    .chart {
      width: 786px;
      height: 622px;
      margin-right: -132px;
    }
  }
}
.box5 {
  width: 100%;
  height: 305px;
  background-image: url("../../../assets/tabs/footBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  .box {
    color: #fff;
    width: 1000px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .leftBox {
      .title {
        font-size: 35px;
        font-weight: 500;
        line-height: 41px;
      }
      .subtitle {
        font-size: 24px;
        font-weight: 500;
        line-height: 28px;
        margin: 26px 0 12px 0;
      }
      .text {
        font-size: 14px;
        line-height: 30px;
      }
    }
    .btn {
      border-radius: 28px;
      padding: 10px 25px;
      background-color: #3359cc;
      border-color: #3359cc;
      color: #fff;
    }
    .btn:hover {
      background-color: #486ad0;
      border-color: #486ad0;
    }
  }
}
// background-image: url("../../../assets/tabs/footBg.png");
</style>